import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import { ApiClient, magic_path } from '@Api';
import { MagicPath, Nullable } from '@Models';
import { RequestAction, RequestFailure } from '@Repository/RequestAction';
import { RequestMagicPathSuccess } from '@Repository/ninthAge/response';
import CacheRepository from '@Repository/CacheRepository';
import { IMapper } from '@Mapper/IMapper';
import { MagicPathMapper } from '@Mapper/ninthAge/MagicPathMapper';

@injectable()
export class MagicPathRepository extends CacheRepository<
  number,
  magic_path,
  magic_path,
  MagicPath
> {
  @inject(TYPES.Mapper.MagicPathMapper)
  private _magicPathMapper!: MagicPathMapper;
  @inject(TYPES.Api.ApiClient) private _apiClient!: ApiClient;

  constructor() {
    super({ key: '/ninth_age/magic_paths' });
  }

  public async get(
    id: number,
    { locale }: { locale?: Nullable<string> },
  ): Promise<RequestAction> {
    try {
      const pathDto = await this._apiClient.ninthAge.getMagicPath({
        locale: locale ?? this._locale.getlocale(),
        pathId: id,
      });
      await this.setCachedEntity({
        data: pathDto,
        locale: locale ?? this._locale.getlocale(),
      });
      return new RequestMagicPathSuccess({
        payload: this._magicPathMapper.map(pathDto),
      });
    } catch (error: any) {
      console.log('error', error);
      return new RequestFailure({ error: error });
    }
  }

  getCached(
    id: number,
    { locale }: { locale?: Nullable<string> },
  ): Promise<Nullable<MagicPath>> {
    return super.getCachedEntity({
      dataId: id,
      locale: locale ?? this._locale.getlocale(),
    });
  }

  protected getMapper(): IMapper<number, magic_path, magic_path, MagicPath> {
    return this._magicPathMapper;
  }
}
